const types = {
    SET_LIST: '[LOTTERY] LIST LOTTERY',
    SET_VIEW: '[LOTTERY] VIEW LOTTERY',
    SET_ID: '[LOTTERY] ID LOTTERY',
    SET_STAT: '[LOTTERY] STAT LOTTERY',
    SET_PRIZE: '[LOTTERY] PRIZE',
    SET_WINNERS: '[LOTTERY] WINNERS',
}

export {
    types
}